import { render, staticRenderFns } from "./NewSignups.vue?vue&type=template&id=52725af5"
import script from "./NewSignups.vue?vue&type=script&lang=js"
export * from "./NewSignups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports